import * as React from 'react';

import { AccessDropdown } from '../access-dropdown';
import { Avatar } from '../avatar';

export const InvitePending = ({
  email,
  role,
  memberId,
  resendInvite = false,
  deleteInvite = false,
  onClickAccessMenuItem,
  accessMenuItems = [],
  handleResendInvite,
  handleDeleteInvite,
  isReadOnly = false,
}: {
  email: string;
  role?: string;
  memberId?: string;
  resendInvite?: boolean;
  deleteInvite?: boolean;
  handleResendInvite?: (memberId: string) => void;
  handleDeleteInvite?: (email: string, memberId: string) => void;
  accessMenuItems?: { title: string; subTitle?: string; value: string }[];
  onClickAccessMenuItem?: (value: string) => void;
  isReadOnly?: boolean;
}) => {
  const [resendInviteClicked, setResendInviteClicked] = React.useState(false);
  const [deleteInviteClicked, setDeleteInviteClicked] = React.useState(false);
  const handleResendInviteClick = () => {
    setResendInviteClicked(true);
    setTimeout(() => {
      setResendInviteClicked(false);
    }, 1000);

    memberId && handleResendInvite?.(memberId);
  };

  const handleDeleteInviteClick = () => {
    setDeleteInviteClicked(true);
    setTimeout(() => {
      setDeleteInviteClicked(false);
    }, 1000);

    memberId && handleDeleteInvite?.(email, memberId);
  };

  return (
    <div className="flex justify-between ml-6 mr-8 text-sm text-gray-600 pt-24">
      <div className="flex">
        <Avatar
          size="md"
          src={
            'https://res.cloudinary.com/samvibes/image/upload/empty%20states/avatar_emoty_state.png'
          }
          name={email}
        />
        <div className="ml-12">
          <p>{email}</p>
          <div className="flex items-center">
            <p className="text-xs">Invite pending</p>
            {resendInvite ? (
              <button
                onClick={handleResendInviteClick}
                className="text-xs rounded-sm text-blue-500 mx-7 font-small"
              >
                {resendInviteClicked ? 'Invite sent' : 'Resend invite'}
              </button>
            ) : null}
            {deleteInvite ? (
              <button
                onClick={handleDeleteInviteClick}
                className="text-xs rounded-sm text-red-500 font-small"
              >
                Delete invite
              </button>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex items-center ">
        <AccessDropdown
          accessLevel={role || 'Member'}
          menuItems={accessMenuItems}
          onClickMenuItem={onClickAccessMenuItem}
          isReadOnly={isReadOnly}
        />
      </div>
    </div>
  );
};
